import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Card} from 'components';
import {TRANSLATION_KEYS} from 'locale';

import type {OverviewResult} from './types';
import {preSessionFlowAnalyticsUtils} from './utils';

const T_KEYS = TRANSLATION_KEYS.USER.ACTIVITY.PRE_SESSION_FLOW.OVERVIEW;

type Props = {
    data?: OverviewResult;
    isLoading: boolean;
};

export const PreSessionFlowOverview = ({data, isLoading}: Props) => {
    const {t} = useTranslation();

    const cards = useMemo(() => {
        const total = data?.totalRuns ?? 0;
        const escalated = data?.escalatedCount ?? 0;
        const abandoned = data?.abandonedCount ?? 0;
        const escalationRate = total > 0 ? Math.round((escalated / total) * 100) : 0;
        const abandonmentRate = total > 0 ? Math.round((abandoned / total) * 100) : 0;
        return [
            {label: t(T_KEYS.TOTAL_RUNS), value: total.toLocaleString()},
            {label: t(T_KEYS.ESCALATION_RATE), value: `${escalationRate}%`},
            {label: t(T_KEYS.ABANDONMENT_RATE), value: `${abandonmentRate}%`},
            {label: t(T_KEYS.AVG_DURATION), value: preSessionFlowAnalyticsUtils.formatStageDuration(data?.avgDurationMs ?? 0)},
        ];
    }, [data, t]);

    return (
        <div className='tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-4'>
            {cards.map((card) => (
                <Card key={card.label} className='tw-rounded'>
                    <div className='tw-ts-code tw-text-default-dimmed'>{card.label}</div>
                    <div className='tw-text-base sm:tw-ts-h5 tw-font-bold'>
                        {isLoading ? '—' : card.value}
                    </div>
                </Card>
            ))}
        </div>
    );
};
